<script lang="ts">
	import { MessengerType } from '$lib/domain/contact/messenger'
	import { _ } from '@repo/i18n'
	import { InputType } from '@repo/ui'
	import { Select } from '@repo/ui'
	import { Input } from '@repo/ui'
	import type { TypesV1Messenger } from '@sdk/Api'
	import { run } from 'svelte/legacy'

	interface Props {
		messenger: TypesV1Messenger
		required?: boolean
	}

	let { messenger = $bindable(), required = false }: Props = $props()

	let messengerType: MessengerType = $state(null)

	function handleMessengerTypeChange(event: CustomEvent<MessengerType>) {
		const messengerType = event.detail

		switch (messengerType) {
			case MessengerType.Signal:
				messenger = {
					signal: { phoneNumber: '' },
				}
				break
			case MessengerType.Skype:
				messenger = {
					skype: { username: '' },
				}
				break
			case MessengerType.Telegram:
				messenger = {
					telegram: { phoneNumber: '' },
				}
				break
			case MessengerType.Whatsapp:
				messenger = {
					whatsapp: { phoneNumber: '' },
				}
				break
			default:
				messenger = {}
				break
		}
	}

	function detectMessengerType(messenger: TypesV1Messenger) {
		if (messenger?.signal) {
			messengerType = MessengerType.Signal
		} else if (messenger?.skype) {
			messengerType = MessengerType.Skype
		} else if (messenger?.telegram) {
			messengerType = MessengerType.Telegram
		} else if (messenger?.whatsapp) {
			messengerType = MessengerType.Whatsapp
		} else {
			messengerType = null
		}
	}
	run(() => {
		detectMessengerType(messenger)
	})
</script>

<Select
	name="messenger"
	label={$_('affiliateRegistrationData.messenger.title')}
	options={[
		{ label: $_('affiliateRegistrationData.messenger.none'), value: null },
		{ label: $_('affiliateRegistrationData.messenger.signal.name'), value: MessengerType.Signal },
		{ label: $_('affiliateRegistrationData.messenger.skype.name'), value: MessengerType.Skype },
		{
			label: $_('affiliateRegistrationData.messenger.telegram.name'),
			value: MessengerType.Telegram,
		},
		{
			label: $_('affiliateRegistrationData.messenger.whatsapp.name'),
			value: MessengerType.Whatsapp,
		},
	]}
	{required}
	bind:value={messengerType}
	on:change={handleMessengerTypeChange}
/>

{#if messengerType === MessengerType.Signal}
	<Input
		name="signalPhoneNumber"
		label={$_('affiliateRegistrationData.messenger.signal.phoneNumber')}
		max={20}
		required
		type={InputType.tel}
		bind:value={messenger.signal.phoneNumber}
	/>
{:else if messengerType === MessengerType.Skype}
	<Input
		name="skypeUserName"
		label={$_('affiliateRegistrationData.messenger.skype.username')}
		max={100}
		required
		bind:value={messenger.skype.username}
	/>
{:else if messengerType === MessengerType.Telegram}
	<Input
		name="telegramPhoneNumber"
		label={$_('affiliateRegistrationData.messenger.telegram.phoneNumber')}
		max={20}
		required
		type={InputType.tel}
		bind:value={messenger.telegram.phoneNumber}
	/>
{:else if messengerType === MessengerType.Whatsapp}
	<Input
		name="telegramPhoneNumber"
		label={$_('affiliateRegistrationData.messenger.whatsapp.phoneNumber')}
		max={20}
		required
		type={InputType.tel}
		bind:value={messenger.whatsapp.phoneNumber}
	/>
{/if}
